<div [class.navigation-arrows]="navigationArrows" class="wrapper">
  <div
    data-at-day-datepicker-previous
    gtm="onChange"
    gtmAction="Previous Day"
    gtmCategory="Hems"
    [class.arrow-disabled]="!canSelectPreviousDay()"
    *ngIf="navigationArrows"
    (click)="onPreviousDay()"
    class="arrow arrow-left"
  >
    <mat-icon>chevron_left</mat-icon>
  </div>
  <mat-form-field appearance="fill">
    <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>
    <input
      data-at-day-datepicker
      matInput
      readonly
      fieldTextContentTooltip
      [min]="minDate"
      [max]="maxDate"
      [matDatepicker]="datepicker"
      [formControl]="datepickerDate"
      (dateChange)="onDateChange($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
    <mat-datepicker #datepicker panelClass="day-datepicker"> </mat-datepicker>
  </mat-form-field>
  <div
    data-at-day-datepicker-next
    gtm="onChange"
    gtmAction="Next Day"
    gtmCategory="Hems"
    [class.arrow-disabled]="!canSelectNextDay()"
    *ngIf="navigationArrows"
    (click)="onNextDay()"
    class="arrow arrow-right"
  >
    <mat-icon>chevron_right</mat-icon>
  </div>
</div>
